import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F1041 {
  f1041_id?: number;
  f1041_01: string;
  f1041_02: number;
  f1041_11: string;  // 地址類別
  f1041_12: string;  // 地址
  f1041_13: string;  // 電話
  f1041_14: string;  // 傳真
}

export interface F1042 {
  f1042_id?: number;
  f1042_01: string;
  f1042_02: string;  // 姓名
  f1042_11: string;  // 職稱類別
  f1042_12: string;  // 職稱
  f1042_13: string;  // 電話
  f1042_14: string;  // 分機
  f1042_15: string;  // Email
}

export interface F1043Credit {
  f1043_01: string;
  f1043_11: string;   // 幣別
  f1043_13: string;   // 收款條件代號
  f1043_131: string;  // 收款條件名稱
  f1043_14: string;   // 付款條件代號
  f1043_141: string;  // 付款條件名稱
  f1043_16: string;   // 收款銀行代號
  f1043_161: number;  // 收款銀行類型
  f1043_162: string;  // 收款銀行帳號
  f1043_17: string;   // 付款銀行代號
  f1043_171: number;  // 付款銀行類型
  f1043_172: string;  // 付款銀行帳號
  f1043_21: number;   // 客戶信用額度
  f1043_22: number;   // 客戶信用已用
  f1043_23: number;   // 客戶信用餘額(計算值)
  f1043_24: number;   // 廠商信用餘額(計算值)
  f1043_25: number;   // 廠商擔保方式
  f1043_26: number;   // 廠商採購額度
  f1043_27: number;   // 已用-採購
  f1043_31: number;   // 受訂金額
  f1043_32: number;   // 出貨金額
  f1043_35: number;   // 客戶擔保方式
  f1043_36: number;   // 採購金額
  f1043_37: number;   // 進貨金額
}

export interface F103 {
  f103_id?: number;
  f103_01: string;   // 公司代號
  f103_12: string;   // 英文姓名
  f103_14: string;   // 性別
  f103_21: string;   // 聯絡電話
  f103_22: string;   // 行動電話
  f103_91?: string;  // 建立人員
  f103_92?: string | null;  // 建立日期
  f103_93?: string;  // 修改人員
}

export interface F1046 {
  f1046_id?: number;
  f1046_01: string;  // 公司代號
  f1046_02: string;  // 下單客戶代號
  f1046_no: number;  // 項次序號
}

export interface F104 {
  f104_01: string;
  f104_02: string;
  f104_11: string;
  f104_12: string;
  f104_13: string;
  f104_14: string;
  f104_21: string;
  f104_22: string;
  f104_23: string;
  f104_24: string;
  f104_28: boolean;
  f104_29: boolean;
  f104_30: string;
  f104_34: string;
  f104_35: boolean;
  f104_39: string;
  f104_41: string;
  f104_42: number;
  f104_91: string;
  f104_92: string | null;
  f104_93: string;
  addresses?: F1041[];
  contacts?: F1042[];
  credit?: F1043Credit | null;
  business_cards?: F103[];
  order_customers?: F1046[];
}

export interface CreateRequest {
  f104_01: string;
  f104_02: string;
  f104_11: string;
  f104_12: string;
  f104_13: string;
  f104_14: string;
  f104_21: string;
  f104_22: string;
  f104_23: string;
  f104_24: string;
  f104_28: boolean;
  f104_29: boolean;
  f104_30: string;
  f104_34: string;
  f104_35: boolean;
  f104_39: string;
  f104_41: string;
  f104_42: number;
  addresses: F1041[];
  contacts: F1042[];
  credit: F1043Credit | null;
  business_cards: F103[];
  order_customers: F1046[];
}

export interface UpdateRequest {
  f104_02: string;
  f104_11: string;
  f104_12: string;
  f104_13: string;
  f104_14: string;
  f104_21: string;
  f104_22: string;
  f104_23: string;
  f104_24: string;
  f104_28: boolean;
  f104_29: boolean;
  f104_30: string;
  f104_34: string;
  f104_35: boolean;
  f104_39: string;
  f104_41: string;
  f104_42: number;
  addresses: F1041[];
  contacts: F1042[];
  credit: F1043Credit | null;
  business_cards: F103[];
  order_customers: F1046[];
}

export interface ListResponse {
  data: F104[];
  total: number;
  page: number;
  size: number;
}

export const companyApi = {
  async list(page = 1, size = 50, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/company', { params });
    return res.data;
  },

  async get(code: string): Promise<F104> {
    const res = await apiClient.get(`/api/company/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F104> {
    const res = await apiClient.post('/api/company', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F104> {
    const res = await apiClient.put(`/api/company/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async copy(data: { new_code: string; from_code: string }): Promise<F104> {
    const res = await apiClient.post('/api/company/copy', data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/company/${encodeURIComponent(code)}`);
  },
};
